(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oreva-supporto"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ov-support')) {
  class OvSupport extends HTMLElement {
    connectedCallback() {
      this.modelBtns = Array.from(this.querySelectorAll('[data-ov-model]'));
      this.topicBtns = Array.from(this.querySelectorAll('[data-ov-topic]'));
      this.panels = Array.from(this.querySelectorAll('[data-ov-panel]'));
      this.answer = this.querySelector('[data-ov-answer]');
      this.subtabs = this.querySelector('[data-ov-subtabs]');
      this.modelTopics = (this.dataset.modelTopics || '').split(',');
      this.desktop = window.matchMedia('(min-width: 1000px)');

      const params = new URLSearchParams(window.location.search);
      const keys = this.modelBtns.map((b) => b.dataset.ovModel);
      this.model = keys.includes(params.get('model')) ? params.get('model') : keys[0];
      const topics = this.topicBtns.map((b) => b.dataset.ovTopic);
      const urlTopic = topics.includes(params.get('topic')) ? params.get('topic') : null;
      this.topic = urlTopic || (this.desktop.matches || this.hasAttribute('data-design-mode') ? this.dataset.defaultTopic : null);
      this.tabIndex = 0;

      this.addEventListener('click', (e) => {
        const m = e.target.closest('[data-ov-model]');
        const t = e.target.closest('[data-ov-topic]');
        const s = e.target.closest('[data-ov-subtab]');
        if (m) { this.model = m.dataset.ovModel; this.tabIndex = 0; this.render(true); }
        if (t) { this.topic = t.dataset.ovTopic; this.tabIndex = 0; this.render(true, true); }
        if (s) { this.tabIndex = Number(s.dataset.ovSubtab); this.render(true); }
        if (e.target.closest('[data-ov-back]')) { this.topic = null; this.render(true); this.querySelector('[data-ov-pick]').scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });

      this._onBlockSelect = (e) => {
        const id = e.detail && e.detail.blockId;
        const panel = id ? this.querySelector(`[data-ov-panel][data-shopify-editor-block*="${id}"]`) : null;
        const btn = id ? this.querySelector(`[data-ov-model][data-shopify-editor-block*="${id}"]`) : null;
        if (btn && !panel) { this.model = btn.dataset.ovModel; this.topic = 'setup'; this.render(); return; }
        if (panel) {
          this.topic = panel.dataset.topic;
          if (panel.dataset.model !== 'all') this.model = panel.dataset.model;
          const visible = this.visiblePanels();
          this.tabIndex = Math.max(0, visible.indexOf(panel));
          this.render();
        }
      };
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }

    visiblePanels() {
      return this.panels.filter((p) => p.dataset.topic === this.topic && (p.dataset.model === 'all' || p.dataset.model === this.model));
    }

    render(updateUrl = false, scroll = false) {
      this.modelBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ovModel === this.model)));
      this.topicBtns.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ovTopic === this.topic)));
      const current = this.modelBtns.find((b) => b.dataset.ovModel === this.model);

      const formModel = this.querySelector('[data-ov-form-model]');
      if (formModel && current) formModel.value = current.dataset.name || this.model;

      if (!this.topic) {
        this.answer.hidden = true;
        this.classList.remove('is-open');
        if (updateUrl) this.updateUrl();
        return;
      }

      this.answer.hidden = false;
      this.classList.add('is-open');
      this.querySelectorAll('[data-ov-title]').forEach((h) => { h.hidden = h.dataset.ovTitle !== this.topic; });

      const forLine = this.querySelector('[data-ov-for]');
      const showFor = this.modelTopics.includes(this.topic) && current;
      forLine.hidden = !showFor;
      if (showFor) {
        this.querySelector('[data-ov-for-name]').textContent = current.dataset.name || '';
        const img = this.querySelector('[data-ov-for-img]');
        if (current.dataset.img) { img.src = current.dataset.img; img.alt = current.dataset.name || ''; img.hidden = false; } else { img.hidden = true; }
      }

      const visible = this.visiblePanels();
      const tabbed = visible.length > 1 && visible.every((p) => p.dataset.tab);
      if (this.tabIndex >= visible.length) this.tabIndex = 0;
      this.panels.forEach((p) => { p.hidden = true; });
      visible.forEach((p, i) => { p.hidden = tabbed ? i !== this.tabIndex : false; });

      this.subtabs.innerHTML = '';
      this.subtabs.hidden = !tabbed;
      if (tabbed) {
        visible.forEach((p, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ov-sup__subtab';
          b.setAttribute('role', 'tab');
          b.dataset.ovSubtab = String(i);
          b.setAttribute('aria-selected', String(i === this.tabIndex));
          b.textContent = p.dataset.tab;
          this.subtabs.appendChild(b);
        });
      }

      if (updateUrl) this.updateUrl();
      if (scroll && !this.desktop.matches) this.answer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    updateUrl() {
      if (this.hasAttribute('data-design-mode')) return;
      const url = new URL(window.location.href);
      if (this.topic) url.searchParams.set('topic', this.topic); else url.searchParams.delete('topic');
      url.searchParams.set('model', this.model);
      window.history.replaceState({}, '', url);
    }
  }
  customElements.define('ov-support', OvSupport);
}

  } catch(e) { console.error(e); }
})();
})();
